import {
    Form,
    InputGroup, OverlayTrigger, Tooltip,
} from "react-bootstrap";
import cabinetStyle from "./MentorCabinet.module.css";
import React from "react";
import InputGroupText from "react-bootstrap/InputGroupText";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";
import {useTranslation} from "react-i18next";

function PlayerSetup(props) {
    const { t } = useTranslation('translation', { keyPrefix: 'groupGamePlayers' });

    const resolvePlayerName = (event) => {
        props.updatePlayerName(props.identifier, event.target.value)
    }

    function resolvePlayerChipName(event) {
        props.updateChipName(props.identifier, event.target.value)
    }

    function resolveColor(event) {
        props.updateColor(props.identifier, event.target.value)
    }

    function resolveDiceType(value) {
        if (value.target.value === "auto") {
            props.updatePlayerDice(props.identifier, true)
        } else if (value.target.value === "manual") {
            props.updatePlayerDice(props.identifier, false)
        }
    }

    const renderChipNameTooltip = () => (
        <Tooltip id="trial-game-tooltip">
            <p>{t('chipNameToolTip1')}</p>
            <p><b>{t('chipNameToolTip2')}</b></p>

        </Tooltip>
    )

    const renderGameStartedTooltip = (props) => (
        <Tooltip {...props}>
            <p>{t('deleteNotAllowedTooltip')}</p>
        </Tooltip>
    )

    return (
        <>
            <Form>
                <Form.Group className={cabinetStyle.playerSetup}>
                    <Form.Control
                        id={"player_name_id"}
                        style={props.playerName.trim() ? {
                            marginBottom: "24px",
                        } : {
                            marginBottom: "24px", border: "0.5px solid red",
                        }}
                        as="input"
                        onChange={e => resolvePlayerName(e)}
                        placeholder={t('playerName')}
                        value={props.playerName}
                    />


                    <Form.Select
                        onChange={resolveDiceType}
                        style={{
                            height: "38px"
                        }}
                        value={props.isAutoDice ? "auto" : "manual"}
                    >
                        <option value={"auto"}>{t('autoDice')}</option>
                        <option value={"manual"}>{t('manualDice')}</option>
                    </Form.Select>

                    <InputGroup className="mb-4">
                        <InputGroupText>{t('chipColor')}</InputGroupText>
                        <Form.Control
                            onChange={resolveColor}
                            type={"color"}
                            value={props.color}
                        />
                    </InputGroup>

                    <OverlayTrigger placement="top-start" delay={{show: 150, hide: 250}}
                                    overlay={renderChipNameTooltip()}>
                        <Form.Control
                            id={"player_name_id"}
                            style={props.chipName.trim() ? {
                                marginBottom: "24px",
                            } : {
                                marginBottom: "24px", border: "0.5px solid red",
                            }}
                            as="input"
                            maxLength={2}
                            onChange={resolvePlayerChipName}
                            placeholder={t('chipSymbols')}
                            value={props.chipName}
                        />
                    </OverlayTrigger>
                </Form.Group>
            </Form>
            <OverlayTrigger placement="top-start" delay={{show: 150, hide: 250}}
                            overlay={props.isStarted ? renderGameStartedTooltip() : <span/>}>
                <HighlightOffOutlinedIcon
                    style={{
                        marginTop: "8px",
                        color: "var(--mentor-cabinet-delete_button)",
                        cursor: "pointer",
                        opacity: props.isStarted ? "0.3" : "1"
                    }}
                    onClick={props.isStarted ? () => {
                    } : () => props.playerDeleter(props.identifier)}
                ></HighlightOffOutlinedIcon>
            </OverlayTrigger>
        </>
    )
}

export default PlayerSetup;